export const WORKER_TOKEN_KEY = 'worker_auth_token';
export const ADMIN_TOKEN_KEY = 'admin_auth_token';
export const FLOOR_MANAGER_TOKEN_KEY = 'floor_manager_token';
export const SUPERADMIN_TOKEN_KEY = 'superadmintoken';